// "We Buy" promotional banners (Chicago buyback). Displayed on /sell and all
// buyback pages. Each image already has its text baked in; caption/alt mirror it.
export const BUYBACK_BANNERS = [
  {
    src: '/images/buyback-banners/we-buy-iphones.webp',
    title: 'We Buy iPhones',
    tagline: 'Sealed or Used \u2022 Top Dollar Paid',
    alt: 'We Buy iPhones in Chicago \u2013 sealed or used, top dollar paid, fast easy local, get cash today at our local Chicago walk-in store',
  },
  {
    src: '/images/buyback-banners/we-buy-ipads.webp',
    title: 'We Buy iPads',
    tagline: 'Sealed or Used \u2022 Top Dollar Paid',
    alt: 'We Buy iPads in Chicago \u2013 sealed or used, top dollar paid, fast easy local, get cash today, local Chicago walk-in, no shipping no hassle',
  },
  {
    src: '/images/buyback-banners/we-buy-macbooks.webp',
    title: 'We Buy MacBooks',
    tagline: 'Sealed or Used \u2022 Top Dollar Paid',
    alt: 'We Buy MacBooks in Chicago \u2013 sealed or used, top dollar paid, fast easy local, get cash today, local Chicago walk-in, no shipping no hassle same day cash',
  },
  {
    src: '/images/buyback-banners/we-buy-sealed-electronics.webp',
    title: 'We Buy Sealed Electronics',
    tagline: 'Sealed \u2022 Brand New \u2022 Top Dollar Paid',
    alt: 'We Buy Sealed Electronics in Chicago \u2013 sealed, brand new, top dollar paid, all brands welcome, get cash today, local Chicago walk-in, no shipping no hassle same day cash',
  },
  {
    src: '/images/buyback-banners/we-buy-all-electronics.webp',
    title: 'We Buy All Your Electronics',
    tagline: 'Sealed or Used \u2022 Top Dollar Paid',
    alt: 'We Buy All Your Electronics in Chicago \u2013 iPhones, iPads, MacBooks, consoles and sealed electronics, all brands all models, top cash offers, no shipping, no hassle, same day cash, local Chicago walk-in',
  },
];
